var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("\n  I "+_vm._s(_vm.step.humanized)+"\n  "),_c('span',{staticClass:"arguments"},_vm._l((_vm.step.args),function(arg){return _c('Argument',{key:arg.toString(),attrs:{"arg":arg}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }